import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BellRing, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { relinkPush, pushSupported } from "../lib/push";
import { usePushState } from "./PushToggle";

const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

function PushBanner() {
  const { on, busy, toggle } = usePushState();
  const [closed, setClosed] = useState(() => localStorage.getItem("fx_push_closed") === "1");
  if (closed || on || Notification.permission !== "default") return null;
  const close = () => { localStorage.setItem("fx_push_closed", "1"); setClosed(true); };
  return (
    <div data-testid="push-prompt-banner" className="fixed bottom-20 md:bottom-4 left-4 right-4 sm:left-auto sm:w-96 z-[60] flex items-center gap-3 px-4 py-3 border border-gold/40 shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-500" style={{ background: "rgba(12,12,14,0.92)", backdropFilter: "blur(16px)" }}>
      <BellRing size={22} className="text-gold shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-white">Signal alerts ON karein</div>
        <div className="text-[11px] text-slate-400">Naya Gold/Bitcoin call aate hi phone pe alert.</div>
      </div>
      <button data-testid="push-prompt-enable" onClick={toggle} disabled={busy} className="px-3 py-2 bg-gold text-black text-xs font-bold hover:brightness-110 transition-[filter] duration-200">ON karein</button>
      <button data-testid="push-prompt-close" onClick={close} className="text-slate-500 hover:text-white transition-colors duration-200"><X size={16} /></button>
    </div>
  );
}

export function PushPrompt() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  useEffect(() => {
    relinkPush();
  }, [user?.id]);
  if (!pushSupported() || !standalone() || pathname === "/join") return null;
  return <PushBanner />;
}
